import { render, staticRenderFns } from "./officialDocProcess_list.vue?vue&type=template&id=4f2ddd01&scoped=true"
import script from "./officialDocProcess_list.vue?vue&type=script&lang=js"
export * from "./officialDocProcess_list.vue?vue&type=script&lang=js"
import style0 from "./officialDocProcess_list.vue?vue&type=style&index=0&id=4f2ddd01&lang=scss"
import style1 from "./officialDocProcess_list.vue?vue&type=style&index=1&id=4f2ddd01&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ddd01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2ddd01')) {
      api.createRecord('4f2ddd01', component.options)
    } else {
      api.reload('4f2ddd01', component.options)
    }
    module.hot.accept("./officialDocProcess_list.vue?vue&type=template&id=4f2ddd01&scoped=true", function () {
      api.rerender('4f2ddd01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/synthesize/officialDocProcess/officialDocProcess_list.vue"
export default component.exports